
import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../utils/IntlMessages";
import "moment/locale/th";
import moment from "moment";

class PopupRedeemStep extends Component {

  
  constructor(props) {
    super(props);
    this.state={
      redeemStep : localStorage.getItem("redeem-step")?localStorage.getItem("redeem-step"):"",
      argument : localStorage.getItem("pdpa-agement")?JSON.parse(localStorage.getItem("pdpa-agement")):"",
    }
  } 


  
  render() { 
    const { locale, authMember } = this.props;
    const display =  this.props.display;
    const date = moment().format("YYYY-MM-DD")

    if((this.state.redeemStep == date || (!this.state.argument || !this.state.argument.id) && display!== true) || (authMember && authMember.success==true)){
      return <></>
    }
    return (
      <div
        className="modal fade show redeem-step"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content white">
            {
                locale === "en" ? <>
                  <div className="modal-header" >
                    <IntlMessages id="redeem-stem.header"></IntlMessages>
                  </div>
                  <div className="modal-body text-left">
                    <div className="redeem-step-header">
                      <IntlMessages id="redeem-stem.self"></IntlMessages>
                    </div>
                    <div className="redeem-flow">
                      <ol>
                        <li><IntlMessages id="redeem-stem.list.1"></IntlMessages></li>
                        <li><IntlMessages id="redeem-stem.list.2"></IntlMessages></li>
                      </ol>
                    </div>
                    <div className="redeem-step-header">
                      <IntlMessages id="redeem-stem.with-staff"></IntlMessages><br/>
                    </div>
                     <div className="redeem-flow">
                      <ol>
                        <li><IntlMessages id="redeem-stem.with-staff-tel.1"></IntlMessages></li>
                        <li><IntlMessages id="redeem-stem.with-staff-tel.2"></IntlMessages></li>
                      </ol>
                      <IntlMessages id="redeem-stem.description"></IntlMessages>
                    </div>
                  </div>
                </>  :  <>
              <div className="modal-header" >
                <IntlMessages id="redeem-stem.header"></IntlMessages>
              </div>
              <div className="modal-body text-left">
                <div className="redeem-step-header">
                  <IntlMessages id="redeem-stem.self"></IntlMessages>
                </div>
                <div className="redeem-flow">
                  <ol>
                    <li><IntlMessages id="redeem-stem.list.1"></IntlMessages></li>
                    <li><IntlMessages id="redeem-stem.list.2"></IntlMessages></li>
                    <li style={{color:"red"}}><IntlMessages id="redeem-stem.list.3"></IntlMessages></li>
                  </ol>
                </div>
                <div className="redeem-step-header">
                  <IntlMessages id="redeem-stem.with-staff"></IntlMessages><br/>
                  <IntlMessages id="redeem-stem.with-staff-tel"></IntlMessages>
                </div>
                <div className="redeem-flow" style={{marginTop:10}}>
                  <IntlMessages id="redeem-stem.description"></IntlMessages>
                </div>
              </div>
              </>
              }
              <div className="modal-footer text-left">
                <button className={"btn btn-wrs mb-3"} 
                  onClick={() => {
                    localStorage.setItem("redeem-step", date);
                    this.setState({
                      redeemStep: date
                    })
                  }}
                >
                  <IntlMessages id="redeem-stem.close"></IntlMessages>
                </button>
              </div>
            
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = ({ setting, auth: { authMember } }) => {
  const {
    locale: { locale },
  } = setting; 
  return { locale, authMember };
};

export default connect(mapStateToProps, {})(PopupRedeemStep);